/**
 * API Header Keys
 * Constants for HTTP header keys used in API requests.
 */
export const API_HEADER_KEYS = {
  AUTHORIZATION: 'Authorization',
  X_ID2_TOKEN: 'X-ID2-Token',
  LPP_ID2_TOKEN: 'x-id2-token',
  X_LPP_ID2_TOKEN: 'x-lpp-id2-token',
  API_KEY: 'x-api-key',
  USER_ID: 'user_id',
} as const
